
<template>
  <div @mousedown='mouseIsDown = true' @mouseup='mouseIsDown = false'>
    <div class='row'>
      <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center w-100 pt-3 pb-2 mb-3 border-bottom" sticky>
        <b-input-group>
          <b-form-input placeholder='Search Lists' v-model='searchText'></b-form-input>
        </b-input-group>
      </div>
    </div>
    <div class='row'>
      <div class="d-flex w-100 justify-content-center mb-3">
        <b-spinner type="grow" label="Loading..." v-if='isBusy' class="float-middle" style="width: 6rem; height: 6rem;"></b-spinner>
      </div>
      <div id='my-lists' class='slide-in-l w-100 px-3' v-if='!isBusy'>
        <b-card class='shadow'>
        <template v-slot:header>
          <b>My Lists</b>
        </template>
        <b-list-group v-if='!isBusy' flush>
          <b-list-group-item
            v-for='(list, idx) in fields'
            :key='idx'
            text-variant="white"
            class="text-left mt-1"
            :variant="selectedList.list_name === list.list_name ? 'info' : 'secondary'"
            @click='hideLists(list)'
            >
            <div :class='list.is_open ? "bg-info" : "bg-dark"' class="justify-content-center">
              <div class='float-left ml-4'>
                <b>{{ titleize(list.list_name) }}</b><br/>
                {{ list.items.length }} {{ list.items.length > 1 ? 'Items' : 'Item' }}<br/>
                Updated: {{ formatDate(list.updated) }}
              </div>
              <div class='float-right'>
                <b-button variant='outline-info' @click.stop='updateStatus(list, "list")'>
                  <font-awesome-icon icon="check" class="icon alt" :style="{visibility: !list.is_open ? 'visible' : 'hidden'}"/>
                </b-button>
              </div>
            </div>
          </b-list-group-item>
        </b-list-group>
        </b-card>
      </div>
      <div id='list-items' v-show='typeof selectedList.list_name !== "undefined" && !isBusy'>
        <b-card class='shadow mb-5'>
          <template v-slot:header bg-variant="primary">
            <b>{{ titleize(selectedList.list_name) }}</b>
            <b-button class="float-right" @click.prevent='showLists()'>X</b-button>
          </template>
          <b-list-group flush>
            <b-list-group-item
              v-for='(item, index) in selectedList.items'
              :key='index'
              :id='"item-" + item.id'
              :class='item.done ? "bg-secondary" : "active-list-item"'
              @mouseenter='mouseIsDown ? getStatus() : activateCanvas(item)'
              @mouseleave='mouseIsDown ? getStatus() : deactivateCanvas(item)'
              @click='!item.done ? updateStatus(item, "item") : getStatus()'>
              <!-- <v-touch @pan="activateCanvas(item)" class='d-flex justify-content-between align-items-center'> -->
              <transition
                  name="ballmove"
                  enter-active-class="bouncein">
                <div v-if="getsDone === item.id && mouseIsDown">
                  <app-child class="ball"></app-child>
                </div>
              </transition>
              <!-- <transition enter-active-class="scratch">
                <div v-if="getsDone === item.id">
                  <app-child></app-child>
                </div>
              </transition> -->
              <div style='left:0%; top:50; position: absolute;'>
                <font-awesome-icon icon="circle" class="icon alt" size='xs'/>
              </div>
              <div class="d-flex w-100 align-items-start px-1">
                <div>
                  <h5 :id='item.id' class='text-break' v-html='formatHtml(item)'></h5>
                  <b-button @click.stop='toggleAttachDrop(item.id)' class='bg-tranparent' v-if='item.file_path'>
                    <font-awesome-icon :icon="paperClip" class="icon alt" :style="{visibility: item.file_path ? 'visible' : 'hidden'}"/>
                  </b-button>
                  <div class='p-1' v-if='attachDrop === item.id && item.file_path'>
                    <b-link :href='item.file_path'>{{ item.file_name }}</b-link>
                  </div>
                </div>
                <b-button class='ml-auto' variant='outline-info' @click.stop='updateStatus(item, "item")' style='z-index: 15'>
                  <font-awesome-icon icon="check" class="icon alt" :style="{visibility: item.done ? 'visible' : 'hidden'}"/>
                </b-button>
              </div>
              <canvas :id='"item-canvas-" + item.id' v-show="getsDone === item.id"></canvas>
              <!-- </v-touch> -->
            </b-list-group-item>
            <b-list-group-item class='flex-column align-items-start'>
              <b-input-group>
                <b-form-input :id='selectedList.list_name + "-add"' placeholder='New Item' v-model='newFields[selectedList.list_name]'></b-form-input>
                <b-input-group-append>
                  <b-button variant='info' @click.prevent='addItem(selectedList.list_name + "-add", selectedList)' v-model='newFields[selectedList.list_name]'>Add</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </div>
      <div class='w-100 bg-dark fixed-bottom' v-if='pendingChanges'>
        <b-button class="m-2 float-right" @click='saveChanges'>Save</b-button>
      </div>
    </div>
  </div>
</template>
<script>

const api = require('@/api.js')
const moment = require('moment-timezone')
const utils = require('@/utils.js')

export default {
  name: 'Home',
  data  () {
    return {
      isBusy: true,
      mouseIsDown: false,
      getsDone: '',
      attachDrop: '',
      paperClip: ['fas', 'paperclip'],
      check: ['fas', 'check'],
      searchText: '',
      allFields: [],
      lists: [],
      selected: [],
      selectedList: [],
      itemStatus: {},
      openLists: {},
      pendingChanges: false,
      updatedFields: {'items': [], 'lists': []},
      newFields: {},
      statuses: {'Done': 3, 'Pending': 1, 'Deleted': 4, 'Maybe Later': 2},
      statusColors: {
        'Done': 'bg-success',
        'Pending': '',
        'Deleted': 'bg-danger',
        'Maybe Later': 'bg-secondary'
      }
    }
  },
  methods: {
    hideLists (list) {
      this.selectedList = list
      // this.selectedList.items.forEach(item => this.activateCanvas(item))
      // var isOpen = listDiv.classList.contains('slide-in-l')
      let baseListClasses = 'w-100 px-4'
      let listDiv = document.getElementById('my-lists')
      listDiv.setAttribute('class', 'slide-out-l ' + baseListClasses)

      let baseItemsClasses = 'w-100 px-4'
      let itemsDiv = document.getElementById('list-items')
      itemsDiv.setAttribute('class', 'slide-in-r ' + baseItemsClasses)
      // this.pendingChanges = true
    },
    toggleAttachDrop (itemId) {
      this.attachDrop === itemId ? this.attachDrop = '' : this.attachDrop = itemId
    },
    showLists () {
      let baseItemsClasses = 'w-100 px-4'
      let itemsDiv = document.getElementById('list-items')
      itemsDiv.setAttribute('class', 'slide-out-r ' + baseItemsClasses)

      let baseListClasses = 'w-100 px-4'
      let listDiv = document.getElementById('my-lists')
      listDiv.setAttribute('class', 'slide-in-l ' + baseListClasses)
      this.selectedList = []
    },
    formatHtml (item) {
      if (item.done) {
        return '<del>' + item.item_name + '</del>'
      } else {
        return item.item_name
      }
    },
    activateCanvas (item) {
      if (!item.done) {
        this.getsDone = item.id
        let container = document.getElementById('item-' + item.id)
        if (!container) { console.log('no container'); return }
        container.style.backgroundColor = 'rgba(0,0,0,.2)'
        utils.canvasUtil.init(container, 'item-canvas-' + item.id)
      }
    },
    deactivateCanvas (item) {
      let container = document.getElementById('item-' + item.id)
      container.style.backgroundColor = ''
    },
    getStatus (itemId) {
      return this.statusColors[status]
    },
    checkInput (field) {
      return this.newFields[field] === ''
    },
    updateStatus (obj, objType) {
      this.pendingChanges = true
      if (objType === 'item') {
        if (!obj.done) {
          this.getsDone = obj.id
        } else {
          this.getsDone = ''
        }
        obj.done = !obj.done
        obj.status = this.itemStatus[obj.id] ? 'Done' : 'Pending'
        this.allFields.find((o, i) => {
          if (o.list_id === obj.list_id) {
            this.allFields[i].items.find((subO, subI) => {
              if (subO.id === obj.id) {
                this.allFields[i].items[subI].done = obj.done
                this.allFields[i].items[subI].status = obj.status
                return true// stop searching
              }
            })
            return true// stop searching
          }
        })
        if (!this.updatedFields.items.find(o => o.id === obj.id)) {
          this.updatedFields.items.push(obj)
        } else {
          this.updatedFields.items.find((o, i) => {
            if (o.id === obj.id) {
              this.updatedFields.items[i] = obj
              return true// stop searching
            }
          })
        }
      } else if (objType === 'list') {
        obj.is_open = !obj.is_open
        let newList = {
          'list_name': obj.list_name,
          'list_id': obj.list_id,
          'is_open': obj.is_open
        }
        this.allFields.find((o, i) => {
          if (o.list_id === obj.list_id) {
            this.allFields[i].is_open = obj.is_open
            return true// stop searching
          }
        })
        if (!this.updatedFields.lists.find(o => o.id === obj.id)) {
          this.updatedFields.lists.push(newList)
        } else {
          this.updatedFields.lists.find((o, i) => {
            if (o.list_id === obj.list_id) {
              this.updatedFields.lists[i] = newList
              return true// stop searching
            }
          })
        }
      }
    },
    titleize (string) {
      if (typeof string !== 'undefined') {
        return string.charAt(0).toUpperCase() + string.slice(1)
      }
    },
    addItem (elem, list) {
      if (this.newFields[list.list_name] !== '') {
        var i
        for (i = 0; i < this.allFields.length; i++) {
          if (this.allFields[i].list_name === list.list_name) {
            this.allFields[i].items.push({
              item_name: this.newFields[list.list_name],
              list_name: list.list_name,
              list_id: list.list_id,
              user_deleted: false,
              from_type: 'ui',
              from_id: 'user',
              done: false,
              id: null,
              status: 'Pending',
              file_name: false
            })
            break
          }
        }
        this.updatedFields.items.push({
          item_name: this.newFields[list.list_name],
          list_name: list.list_name,
          list_id: list.list_id,
          user_deleted: false,
          from_type: 'ui',
          from_id: 'user',
          done: false,
          id: null,
          status: 'Pending',
          file_name: false
        })
        this.pendingChanges = true
        this.newFields[list.list_name] = ''
        let input = document.getElementById(elem)
        input.value = ''
      } else { console.log(`${list.list_name}'s new item is empty`) }
    },
    formatDate (dateStr) {
      let d = moment(dateStr).tz('America/New_York')
      return d.format('MMM DD YYYY')
    },
    pendingChangesFalse () {
      this.pendingChanges = true
    },
    async saveChanges () {
      this.isBusy = true
      await api.exec.saveChanges(this.updatedFields)
      this.allFields = this.allFields.filter((element) => element.items.some((item) => item.status !== 'Deleted'))
        .map(element => {
          return Object.assign({}, element, {items: element.items.filter(item => item.status !== 'Deleted')})
        })
      this.allFields.forEach((el, idx) => { el.items.sort((a, b) => (this.statuses[a.status] > this.statuses[b.status]) ? 1 : -1) })
      this.isBusy = this.pendingChanges = false
    }
  },
  computed: {
    fields () {
      let resp = this.allFields.filter(element => (element.list_name.toLowerCase().includes(this.searchText.toLowerCase()) || element.items.some((item) => item.item_name.toLowerCase().includes(this.searchText.toLowerCase()))) && element.items.length > 0)
        .map(element => {
          return Object.assign({},
            element, {items: element.items.filter(item => item.item_name.toLowerCase().includes(this.searchText.toLowerCase()))})
        })
      resp.sort((a, b) => (new Date(a.updated) < new Date(b.updated)) ? 1 : -1)
      return resp
    },
    viewedList () {
      return this.selectedList.items
    }
  },
  async beforeCreate () {
    this.allFields = await api.exec.userList('1') // '1' for open lists
    this.allFields.forEach((el, idx) => {
      el.items.sort((a, b) => (this.statuses[a.status] > this.statuses[b.status]) ? 1 : -1)
      el.items.forEach((el) => {
        this.itemStatus[el.id] = el.done
      })
    })
    this.selectedList = this.allFields[0].items
    this.lists = await this.allFields.map((i, idx) => i.list_name)
    this.lists.forEach((el, idx) => { this.$set(this.newFields, el, ''); this.$set(this.openLists, el, false) })
    this.isBusy = false
  }
}
</script>

<style scoped>
@mixin ballb($xaxis: 0) {
  transform: translateX($xaxis);
}

@keyframes bouncein {
  0% { transform: translateX(0px); }
  100% { transform: translateX(1000px); }
}

@keyframes scratch-out {
  0% { width: 10px; }
  100% { width: 1000px; }
}

@keyframes rollout {
  0% { transform: translate3d(0, 0, 0); }
  /*100% { @include fuckcss(1000px); }*/
  100% { transform: translate3d(1000px, 0, 0); }
}

@keyframes ballroll {
  0% { transform: rotate(0); }
  100% { transform: rotate(2000deg); }
}

/*.ballmove-enter {
  color: red;
}*/

.bouncein {
  position: relative;
  z-index: 1000;
  animation: bouncein 5s;
  top: 40%;
}

.rollout {
  position: absolute;
  z-index: 1000;
  width: 60px;
  height: 60px;
  animation: rollout 20s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
  div {
    animation: ballroll 2s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
  }
}
.ball {
  position: absolute;
  z-index: 1000;
  width: 60px;
  height: 60px;
  background: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/28963/soccerball.svg");
  animation: ballroll 5s cubic-bezier(0.55, 0.85, 0.68, 0.53) both;;
  /*transform-origin: 50% 50%;*/
}
.scratch {
  position: absolute;
  z-index: 999;
  height: 20px;
  top: 40%;
  background-color: black;
  animation: scratch-out 5s;
  transform: translateX(20px);
}

#my-lists {
    position: absolute;
    /*overflow: hidden;*/
    transform: translateX(-100%);
    -webkit-transform: translateX(-100%);
}

.slide-in-l {
    animation: slide-in-l 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53);
    -webkit-animation: slide-in-l 0.5s forwards;
}

.slide-out-l {
    animation: slide-out-l 0.5s cubic-bezier(0.95, 0.085, 0.68, 0.53);
    -webkit-animation: slide-out-l 0.5s forwards;
}

@keyframes slide-in-l {
    100% { transform: translateX(0%); }
}

@-webkit-keyframes slide-in-l {
    100% { -webkit-transform: translateX(0%); }
}

@keyframes slide-out-l {
    0% { transform: translateX(0%); }
    100% { transform: translateX(-100%); }
}

@-webkit-keyframes slide-out-l {
    0% { -webkit-transform: translateX(0%); }
    100% { -webkit-transform: translateX(-100%); }
}
#list-items {
    position: absolute;
    /*overflow: hidden;*/
    transform: translateX(100%);
    -webkit-transform: translateX(100%);
}

.slide-in-r {
    animation: slide-in-r 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53);
    -webkit-animation: slide-in-r 0.5s forwards;
}

.slide-out-r {
    animation: slide-out-r 0.5s cubic-bezier(0.99, 0.085, 0.68, 0.53);
    -webkit-animation: slide-out-r 0.5s forwards;
}

@keyframes slide-in-r {
    100% { transform: translateX(0%); }
}

@-webkit-keyframes slide-in-r {
    100% { -webkit-transform: translateX(0%); }
}

@keyframes slide-out-r {
    0% { transform: translateX(0%); }
    100% { transform: translateX(100%); }
}

@-webkit-keyframes slide-out-r {
    0% { -webkit-transform: translateX(0%); }
    100% { -webkit-transform: translateX(100%); }
}
</style>



// WEBPACK FOOTER //
// src/components/openlistsDev.vue